import { Node } from "@tiptap/core";
import Document from "@tiptap/extension-document";

import type { Alignment } from "./BlockAlign";

export type DocumentTitleAttrs = {
  alignment: Alignment;
};

export const DocumentTitleDocument = Document.extend({
  name: "documentTitleSchema",
  content: "documentTitle block*",
});

export const DocumentTitleNode = Node.create({
  name: "documentTitle",
  content: "inline*",
  group: "title",

  parseHTML() {
    return [{ tag: "h1:first-child" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["h1", HTMLAttributes, 0];
  },
});
